import { render, staticRenderFns } from "./SelectInputField.vue?vue&type=template&id=19b4703b&scoped=true"
import script from "./SelectInputField.vue?vue&type=script&lang=js"
export * from "./SelectInputField.vue?vue&type=script&lang=js"
import style0 from "./SelectInputField.vue?vue&type=style&index=0&id=19b4703b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b4703b",
  null
  
)

export default component.exports